import { parseISO } from 'date-fns'

const isDateObjectValid = (date: Date): boolean => {
  if (!(date instanceof Date)) {
    return false
  }

  if (isNaN(date.getTime())) {
    return false
  }

  return true
}

// 2020-01-01 or 2020-01-01T00:00:00 is an ISO8601 date
export const isIso8601DateString = (dateString: string): boolean => {
  const date: Date = parseISO(dateString)
  const isDateObjValid = isDateObjectValid(date)

  return isDateObjValid
}
